export default __webpack_public_path__ + "static/media/Y20.ff621518.jpg";